<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Başvuru Formu</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Mağaza Adı</h4>
          <v-text-field
            v-model="application.companyName"
            maxlength="255"
            counter="255"
            :rules="companyNameRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Yetkili Ad Soyad</h4>
          <v-text-field
            v-model="application.fullName"
            maxlength="255"
            counter="255"
            :rules="fullNameRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Telefon Numarası</h4>
          <v-text-field
            v-model="application.phoneNumber"
            maxlength="50"
            counter="50"
            v-mask="'+90##########'"
            :rules="phoneRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Mail Adresi</h4>
          <v-text-field
            v-model="application.email"
            maxlength="255"
            counter="255"
            :rules="emailRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <h4>Adres</h4>
          <v-textarea
            v-model="application.address"
            maxlength="255"
            counter="255"
            rows="1"
            auto-grow
            :rules="addressRules"
            required
          ></v-textarea>
        </v-col>

        <v-col cols="12" md="8"></v-col>
      </v-row>

      <v-col cols="12" md="7">
        <v-btn
          depressed
          color="#4d48f9"
          style="
            text-transform: none !important;
            float: right;
            color: white;
            margin-bottom: 30px;
          "
          @click="postApplicationForm()"
        >
          Başvur
        </v-btn>
      </v-col>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-toolbar-title style="width: 300px;" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">
          <img src="@/assets/frink_beyaz_logo.png" style="width: 100px;" />
        </span>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import app from '@/App.vue'

export default {
  data: () => ({
    application: {
      companyName: '',
      address: '',
      fullName: '',
      phoneNumber: '',
      email: '',
    },

    valid: true,
    companyNameRules: [
      (v) => !!v || 'Mağaza adı alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    fullNameRules: [
      (v) => !!v || 'Ad ve soyadı doğru bir formatta yazınız.',
      (v) => v.length <= 255 || 'Ad ve soyadı doğru bir formatta yazınız.',
      (v) => {
        const parts = v
          .trim()
          .split(' ')
          .filter((part) => part.length > 0)
        return (
          (parts.length >= 2 && parts.every((part) => part.length >= 2)) ||
          'Ad ve soyadı doğru bir formatta yazınız.'
        )
      },
      (v) =>
        /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]*$/.test(v) ||
        'Ad ve soyadı doğru bir formatta yazınız.',
    ],

    phoneRules: [
      (v) => !!v || 'Yetkili telefon alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
      (v) => v.length >= 11 || 'En az 7 karakter girmelisiniz.',
    ],
    addressRules: [
      (v) => !!v || 'Adres alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    emailRules: [
      (v) => !!v || 'Email alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Lütfen geçerli bir mail adresi giriniz.',
    ],

    errorList: [],
    dialog: false,
  }),

  computed: mapGetters([]),

  methods: {
    ...mapActions(['sendApplicationForm']),
    postApplicationForm() {
      if (this.$refs.form.validate()) {
        this.sendApplicationForm(this.application).then((response) => {
          if (response.processStatus == 'Success') {
            alert(
              "Başvurunuz Frink Ekibi'ne iletildi. En kısa sürede satış temsilcimiz sizinle iletişime geçiyor olacak. İlginiz için teşekkür ederiz, en kısa sürede Frink noktaları arasında sizleri de görmek isteriz. Bol kahveli günler!",
            )
            this.$router.go(this.$router.currentRoute)
          } else {
            alert('Başvuru işlemi gerçekleştirilemedi')
          }
        })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)
        this.errorList = errors
        this.dialog = true
      }
    },
  },
}
</script>
